import { useCallback, useState } from 'react';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { EmployeeFormFields } from 'src/components/enterprise/features/Employee/components/Form/types/EmployeeForm';
import { createEmployee } from 'src/components/enterprise/features/Employee/CreatePage/api/createEmployeeApi';
import { Employee } from 'src/types/Employee';

export type UseCreateEmployeeReturnType = {
  createEmployee: (values: EmployeeFormFields) => Promise<void>;
  isLoading: boolean;
};

export type UseCreateEmployeeProps = {
  corpId: string;
  onSuccess: (employee: Employee) => Promise<void>;
  onError: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
};

export const useCreateEmployee = ({
  corpId,
  onSuccess,
  onError,
}: UseCreateEmployeeProps): UseCreateEmployeeReturnType => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createEmployeeTrigger = useCallback(
    async (values: Employee): Promise<void> => {
      try {
        setIsLoading(true);
        const { id } = await createEmployee(corpId, values);
        await onSuccess({ ...values, id });
      } catch (error) {
        await onError(error);
        setIsLoading(false);
      }
    },
    [corpId, onSuccess, onError]
  );

  return {
    createEmployee: createEmployeeTrigger,
    isLoading,
  };
};
